// 商户产品关联模拟数据
export const merchantProductList = [
  {
    id: 1,
    merchantNo: '商户A',
    merchantName: '商户A',
    productName: '产品A',
    productCode: '8888',
    rate: 10.00,
    weight: 1,
    remark: '',
    customOption: true,
    balanceType: 'polling',
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 }
    ]
  },
  {
    id: 2,
    merchantNo: '商户A',
    merchantName: '商户A',
    productName: '产品B',
    productCode: 'WX001',
    rate: 3.50,
    weight: 10,
    remark: '产品B优先',
    customOption: true,
    balanceType: 'weight',
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 }
    ]
  },
  {
    id: 3,
    merchantNo: '商户A',
    merchantName: '商户A',
    productName: '产品C',
    productCode: 'ZFB001',
    rate: 3.00,
    weight: 8,
    remark: '产品C次优先',
    customOption: true,
    balanceType: 'polling',
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 },
      { name: '渠道D', rate: 6 }
    ]
  },
  {
    id: 4,
    merchantNo: '商户B',
    merchantName: '商户B',
    productName: '产品A',
    productCode: 'YL001',
    rate: 2.80,
    weight: 5,
    remark: '标准费率',
    customOption: true,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 }
    ]
  },
  {
    id: 5,
    merchantNo: '商户B',
    merchantName: '商户B',
    productName: '产品B',
    productCode: 'YSF001',
    rate: 2.50,
    weight: 7,
    remark: '优惠费率',
    customOption: true,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 }
    ]
  },
  {
    id: 6,
    merchantNo: '商户B',
    merchantName: '商户B',
    productName: '产品C',
    productCode: 'ZFB002',
    rate: 3.20,
    weight: 9,
    remark: '特约商户',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 }
    ]
  },
  {
    id: 7,
    merchantNo: '商户C',
    merchantName: '商户C',
    productName: '产品A',
    productCode: 'ICC001',
    rate: 4.50,
    weight: 3,
    remark: '高费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 }
    ]
  },
  {
    id: 8,
    merchantNo: '商户C',
    merchantName: '商户C',
    productName: '产品B',
    productCode: 'QP001',
    rate: 2.60,
    weight: 6,
    remark: '标准费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 },
      { name: '渠道D', rate: 6 }
    ]
  },
  {
    id: 9,
    merchantNo: '商户C',
    merchantName: '商户C',
    productName: '产品C',
    productCode: 'AGG001',
    rate: 3.80,
    weight: 4,
    remark: '综合费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 }
    ]
  },
  {
    id: 10,
    merchantNo: '商户D',
    merchantName: '商户D',
    productName: '产品A',
    productCode: 'SCAN001',
    rate: 2.20,
    weight: 8,
    remark: '优惠费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 }
    ]
  },
  {
    id: 11,
    merchantNo: '商户D',
    merchantName: '商户D',
    productName: '产品B',
    productCode: 'WX002',
    rate: 3.30,
    weight: 7,
    remark: '标准费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 }
    ]
  },
  {
    id: 12,
    merchantNo: '商户E',
    merchantName: '商户E',
    productName: '产品A',
    productCode: 'ZFB003',
    rate: 2.90,
    weight: 5,
    remark: '标准费率',
    customOption: false,
    selectedChannels: [
      { name: '渠道A', rate: 6 },
      { name: '渠道B', rate: 6 },
      { name: '渠道C', rate: 6 }
    ]
  }
];